module.exports = __webpack_public_path__ + "static/media/wifi.697ead95.svg";